export enum TransactionEvaluationMethodTypeEnum {
  PBA = 1,
  TBA,
}
